import { render, staticRenderFns } from "./IVMessage.vue?vue&type=template&id=1fe2e998&"
import script from "./IVMessage.vue?vue&type=script&lang=js&"
export * from "./IVMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports